import type { Coding } from "@medplum/fhirtypes";
import { RXNORM_SYSTEM } from "@repo/fhir-systems";
import { useNlmSearch } from "@/shared/hooks/use-nlm-search";

const NLM_API = "https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search";

export interface RxStrengthOption {
  rxcui: string;
  label: string;
  coding: Coding;
}

/** An RxTerms drug name carries no RxCUI of its own; only its strengths do. */
export interface RxDrugOption {
  name: string;
  strengths: RxStrengthOption[];
}

const searchConfig = {
  endpoint: NLM_API,
  params: "ef=STRENGTHS_AND_FORMS,RXCUIS",
  parse(data: [number, string[], { STRENGTHS_AND_FORMS?: string[][]; RXCUIS?: string[][] } | null]): RxDrugOption[] {
    const names = data[1] ?? [];
    const strengths = data[2]?.STRENGTHS_AND_FORMS ?? [];
    const rxcuis = data[2]?.RXCUIS ?? [];
    return names.map((name, i) => ({
      name,
      strengths: (rxcuis[i] ?? []).map((rxcui, j) => {
        const label = (strengths[i]?.[j] ?? "").trim();
        return { rxcui, label, coding: { system: RXNORM_SYSTEM, code: rxcui, display: `${name} ${label}`.trim() } };
      }),
    }));
  },
};

export function useRxNormSearch(query: string) {
  return useNlmSearch(query, searchConfig);
}
